<template>
  <section class="banner-detail">
    <div class="abs-top-right">
      <v-button @click="() => $router.back()">Back</v-button>
    </div>
    <h1>Banner</h1>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="flex ">
        <div class="form-item ">
          <!--        <span>3x</span>-->
          <el-form-item
            label="3x"
            prop="thumb_url">
            <v-upload
              :notUpload="true"
              :fileData="fileData"
              :card="true"
              @uploadForm="handlerUploadSuccess"
              @delete="handlerUploadDelete" />
          </el-form-item>
        </div>
      </div>
      <h2>Promotion Settings</h2>

      <el-radio-group
        v-model="formData.type"
        class="type-container ">
        <el-radio :label="2">
          <div
            class="form-item"
            :class="{'mask-container': formData.type != 2}">
            <span class="margin-bottom">Destination Product</span>
            <el-form-item
              :prop="formData.type == 2?'product_id':''">
              <v-select
                v-model="formData.product_id"
                :list="productTypeOptions"/>
            </el-form-item>
          </div>
        </el-radio>
        <el-radio :label="4">
          <div
            class="form-item margin-top"
            :class="{'mask-container': formData.type != 4}">
            <span>URL</span>
            <v-input
              v-if="formData.type != 4"
              v-model="formData.url"/>
            <el-form-item
              v-else
              prop="url">
              <v-input v-model="formData.url"/>
            </el-form-item>
          </div>
        </el-radio>
      </el-radio-group>

      <div class="form-item">
        <span>Privacy</span>
        <v-checkbox v-model="isHide">Do not show in list</v-checkbox>
      </div>
      <h2>Publish</h2>
      <div class="flex publish-container">
        <div class="form-item">
          <!--          <span>Start Date</span>-->
          <el-form-item
            label="Start Date"
            prop="start_time">
            <v-date-picker v-model="formData.start_time" />
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item
            label="End Date "
            prop="end_time">
            <v-date-picker v-model="formData.end_time" />
          </el-form-item>
        </div>
      </div>
    </el-form>
    <v-button
      type="primary"
      @click="onSave">Save</v-button>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { createAdvert, getAdvertDetail, updateAdvert } from '@/api/news'
import MixinRules from '@/mixins/rules'
export default {
  name: 'BannerDetail',
  mixins: [MixinOptions,MixinRules],
  data() {
    return {
      formData: {
        type: 2,  // in [1,2,3,4] 2-product 4-url 1-page_name 3-news
        start_time: '',
        end_time: '',
        url: '',
        product_id: '',
        thumb_url:'',
      },
      type:2,
      isHide: false,
      uploadParams: null,
      fileData: {
        url: '',
        thumb_url: ''
      }
    }
  },
  computed: {
    advertId() {
      return this.$route.query.id
    },
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        const { id } = this.$route.query
        if(id) {
          this.network().getAdvertDetail({
            advert_id: id
          })
        }
      }
    },
    'fileData.thumb_url':{
      immediate: true,
      handler(val) {
        if(val) {
          this.$set(this.formData, 'thumb_url', val)
        }
      }
    },
  },
  methods: {
    handlerUploadSuccess({ params, result, otherData }) {
      // 這裏還要上傳
      // this.network().uploadNewsImage({ params, result, otherData })
      const { url } = result
      this.fileData.thumb_url = url
      this.fileData.url = url
      this.uploadParams = params // params 是 new FormData 對象

      this.$refs['form'].clearValidate(['thumb_url'])

    },
    handlerUploadDelete({ params, result, otherData }) {
      // const { url } = result
      this.fileData.thumb_url = ''
      this.fileData.url = ''
      this.uploadParams = null

      this.$refs['form'].clearValidate(['thumb_url'])

    },
    onSave() {
      let params
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.uploadParams) {
            params = this.uploadParams
          } else {
            params = new FormData()
          }

          Object.keys(this.formData).some(key => {
            this.formDataAppend(params, key, this.formData[key])
            // if(params.has(key)) {
            //   params.set(key, this.formData[key])
            // }
            // else {
            //   params.append(key, this.formData[key])
            // }
          })
          // if(params.has('is_show')) {
          //   params.set('is_show', this.isHide ? 0 : 1)
          // }
          // else {
          //   params.append('is_show', this.isHide ? 0 : 1)
          // }
          this.formDataAppend(params, 'is_show', this.isHide ? 0 : 1)
          
          if (this.advertId) {
            // if(params.has('advert_id')) {
            //   params.set('advert_id', this.advertId)
            // }
            // else {
            //   params.append('advert_id', this.advertId)
            // }
            this.formDataAppend(params, 'advert_id', this.advertId)
            this.network().updateAdvert(params)
          } else {
            this.network().createAdvert(params)
          }
        }
      })
    },
    formDataAppend(origin, key, value) {
      if(origin.has(key)) {
        origin.set(key, value)
      }
      else {
        origin.append(key, value)
      }
    },
    network() {
      return {
        createAdvert: async params => {
          const { data } = await createAdvert(params)
          this.$router.push({
            path: '/administration/web/content',
            query: {
              tab: 'Home'
            }
          })
        },
        updateAdvert: async params => {
          const { data } = await updateAdvert(params)
          this.$router.push({
            path: '/administration/web/content',
            query: {
              tab: 'Home'
            }
          })
        },
        getAdvertDetail: async params => {
          const { data } = await getAdvertDetail(params)
          Object.keys(this.formData).some(key => {
            this.formData[key] = data.data[key]
          })
          const { is_show, banner_url } = data.data
          this.isHide = is_show === 1? false: true
          this.fileData.thumb_url = banner_url
          this.fileData.url = banner_url
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-detail {
  position: relative;
  /deep/ .upload-card {
    width: 250px;
  }
  .publish-container {
    .form-item {
      margin-right: 15px;
    }
  }
  .type-container {
    .el-radio {
      display: flex;
      align-items: center;
    }
  }
  .margin-top{
    //margin-top: 15px;
  }
}
</style>